export default __webpack_public_path__ + "static/media/astronaut (1).4b203a0b.png";